import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NewsNotifications } from '../objects/news-notifications';

@Injectable({
  providedIn: 'root'
})
export class NewsNotificationsService {
  public news: Observable<NewsNotifications>;
  private newsSubject: BehaviorSubject<NewsNotifications>;

  constructor() {
    this.newsSubject = new BehaviorSubject(new NewsNotifications());
    this.news = this.newsSubject.asObservable();
  }

  public getState(): NewsNotifications {
    return this.newsSubject.getValue();
  }

  public setState(news: NewsNotifications): void {
    this.newsSubject.next(news);
  }
}
